import React, { useEffect, useRef, useState } from "react";
import { Row, Space, Spin } from "antd";
import PatientInfo, {
  PatientInfoRef,
} from "./components/PatientInfo/PatientInfo";
import { StepInfo } from "components/common";

import { useAppDispatch, useAppSelector } from "redux/hooks";
import residentialNurseService from "api/residentialNurse";
import {
  setActiveKey,
  setButtonsHeader,
  setIdPhieuKham,
} from "redux/reducer/common";
import { residentialNurse } from "types/enums/residential-nurse";
import Notification from "components/common/notification/notification";
import { setDetailInfo, setIsChangetab } from "redux/reducer/residentialNurse";
import {
  Cancel,
  Completed,
  Pause,
  PrintCertificate,
  Save,
  SaveAndPrint,
} from "pages/Refractive/InforDetails/config";
import SurgeryDetail from "./components/SurgeryDetail/SurgeryDetail";
import PersonalInfo from "./components/PersonelInfo/PersonelInfo";
import ModalCustom from "components/common/ModalCustom/ModalCustom";
import PrintPhieuPT from "./components/PrintPhieuPT/PrintPhieuPT";
import SurgeryCertificate from "./components/SurgeryCertificate/SurgeryCertificate";
import "./Detail.scss";

const DetailInfo = () => {
  const [loading, setLoading] = useState(false);

  const surgeryDetailRef = useRef<PatientInfoRef | null>(null);
  const patientInfoRef = useRef<PatientInfoRef | null>(null);
  const personalInfoRef = useRef<PatientInfoRef | null>(null);
  const [listButton, setListButton] = useState<any[]>([]);
  const [personalInfo, setPerenalInfo] = useState(null);
  const [surgeryDetail, setSurgeryDetail] = useState(null);

  const [infoDataPatient, setInfoPatient] = useState(null);

  const [detailPatient, setDetailPatient] = useState(null);

  const idSurgery = useAppSelector((e) => e.residentialNurse.idSurgery);

  const modalRef = useRef<any>();
  const modalRefSurgeryCertificate = useRef<any>();

  const detailInfo = useAppSelector((e) => e.residentialNurse.detailInfo);

  const activeKey = useAppSelector((e) => e.common.activeTab);

  const dispatch = useAppDispatch();

  //thông tin bệnh nhân
  const getPatientInfo = async () => {
    setLoading(true);
    try {
      const res = await residentialNurseService.getPatientInfoById(idSurgery);

      dispatch(setIdPhieuKham(res.idPhieuKham));

      if (res?.idTrangThaiPhauThuat === 1) {
        const params = {
          idphieuphauthuat: idSurgery,
          idtrangthaiphauthuat: 2,
        };
        await residentialNurseService.updateStatusSurgery(params);

        setInfoPatient((pre) => ({ ...pre, ...res, idTrangThaiPhauThuat: 2 }));
      } else {
        setInfoPatient((pre) => ({ ...pre, ...res }));
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (idSurgery) {
        Notification("error", "Đã xảy ra lỗi trong khi lấy dữ liệu");
      } else Notification("error", "Không có thông tin phiếu khám");
    }
  };

  //chi tiết quá trình phẫu thuật
  const getDetailInfoById = async () => {
    if (idSurgery !== null) {
      try {
        const res = await residentialNurseService.getDetailInfoById(idSurgery);

        setPerenalInfo(res.nhanSuPhauThuat);

        setSurgeryDetail(res);
        setLoading(false);

        setDetailPatient((pre) => ({ ...pre, ...res }));
      } catch (error) {
        setLoading(false);
        Notification(
          "error",
          "Đã xảy ra lỗi khi lấy chi tiết thông tin bệnh nhân"
        );
      }
    }
  };

  useEffect(() => {
    dispatch(setDetailInfo({ ...detailPatient, ...infoDataPatient }));
  }, [detailPatient, infoDataPatient]);
  //đổi trạng thái
  const postStatusDiagnoseForm = async (idTrangThaiPhauThuat, status) => {
    setLoading(true);
    try {
      const params = {
        idphieuphauthuat: idSurgery,
        idtrangthaiphauthuat: idTrangThaiPhauThuat,
      };
      await residentialNurseService.updateStatusSurgery(params);

      setLoading(false);
      if (idTrangThaiPhauThuat != 2) {
        Notification("success", `Cập nhật trạng thái ${status} thành công`);
      }
      dispatch(setIsChangetab(false));
    } catch (error) {
      setLoading(false);

      Notification("error", `Cập nhật trạng thái ${status} không thành công`);
    }
  };

  const handleComplete = async () => {
    const chiTiet = surgeryDetailRef.current.getFormValue();
    // const patientInfor = patientInfoRef.current?.getFormValue();

    // const res = disableBtn(patientInfor?.ngayKham);
    // if (res) {
    //   modalAlertRef.current.openModal();
    //   setLoading(false);
    //   return;
    // }
    if (!chiTiet?.thoiGianBatDau) {
      Notification("warning", "Chưa nhập thời gian bắt đầu");
      return;
    } else if (!chiTiet?.thoiGianKetThuc) {
      Notification("warning", "Chưa nhập thời gian kết thúc");
      return;
    }
    await handleSave();
    await postStatusDiagnoseForm(3, "hoàn thành");
    dispatch(setActiveKey(residentialNurse.SURGERY.LIST_PATIENT));
  };

  // const handleSave = async () => {
  //   setLoading(true);

  //   const personalInfo = personalInfoRef.current?.getFormValue();
  //   console.log("🚀 ~ handleSave ~ personalInfo:", personalInfo);
  //   const patientInfor = patientInfoRef.current?.getFormValue();

  //   const surgeryDetail = surgeryDetailRef.current?.getFormValue();

  //   const newData = {
  //     ...infoDataPatient,
  //     ...detailPatient,
  //     ...patientInfor,
  //     idPhieuKham: infoDataPatient?.idPhieuKham,
  //     nhanSuPhauThuat: {
  //       ...personalInfo,
  //     },
  //     quaTrinhPhauThuat: {
  //       ...surgeryDetail,
  //     },
  //     dichVu: infoDataPatient.dichVu,
  //     ngayChiDinh: patientInfor?.ngayChiDinh,
  //   };
  //   console.log("🚀 ~ handleSave ~ newData:", newData);
  //   const arrEmpty = [];
  //   Object.entries({ ...personalInfo, ...surgeryDetail }).forEach(
  //     ([key, value]) => {
  //       if (!value || value == null) {
  //         arrEmpty.push({
  //           [key]: value,
  //         });
  //       }
  //     }
  //   );
  //   console.log("🚀 ~ handleSave ~ arrEmpty:", arrEmpty);

  //   if (Object.values((e) => console.log(e))) {
  //     <ModalCustom ref={modalAlertRef} width={600} title={"Cảnh báo"}>
  //       <AlertModal
  //         message={"Các trường dưới đây chưua được nhập. Bạn có muốn lưu?"}
  //       >
  //         <ul>
  //           {arrEmpty.map((e) => (
  //             <li style={{ fontWeight: "bold" }}>{e.name}</li>
  //           ))}
  //         </ul>
  //       </AlertModal>
  //     </ModalCustom>;
  //   }
  //   try {
  //     // const res = await residentialNurseService.updateDetailSurgery(
  //     //   idSurgery,
  //     //   newData,
  //     //   infoDataPatient?.idPhieuKham ?? null
  //     // );
  //     // const res2 = await residentialNurseService.updatePatientInfoById(
  //     //   idSurgery,
  //     //   patientInfor
  //     // );

  //     // setPerenalInfo(res.nhanSuPhauThuat);

  //     // const res2 = await residentialNurseService.getPatientInfoById(idSurgery);
  //     // setSurgeryDetail({ ...res, ...res2, ngayChiDinh: res2.ngayChiDinh });
  //     // dispatch(setDetailInfo({ ...infoDataPatient, ...res, ...res2 }));

  //     // setAllPatient((pre) => ({ ...pre, ...res }));

  //     setLoading(false);
  //     Notification("success", "Lưu dữ liệu thành công");
  //   } catch (error) {
  //     Notification("error", "Lưu dữ liệu thất bại");
  //     setLoading(false);
  //   }
  // };

  const handleSave = async () => {
    setLoading(true);

    const personalInfo = personalInfoRef.current?.getFormValue();
    const patientInfor = patientInfoRef.current?.getFormValue();

    const surgeryDetail = surgeryDetailRef.current?.getFormValue();

    try {
      const newData = {
        ...infoDataPatient,
        ...detailPatient,
        ...patientInfor,
        idPhieuKham: infoDataPatient?.idPhieuKham,
        nhanSuPhauThuat: {
          ...personalInfo,
        },
        quaTrinhPhauThuat: {
          ...surgeryDetail,
        },
        dichVu: infoDataPatient.dichVu,
        ngayChiDinh: patientInfor?.ngayChiDinh,
      };

      const res = await residentialNurseService.updateDetailSurgery(
        idSurgery,
        newData,
        infoDataPatient?.idPhieuKham ?? null
      );
      // const res2 = await residentialNurseService.updatePatientInfoById(
      //   idSurgery,
      //   patientInfor
      // );

      setPerenalInfo(res.nhanSuPhauThuat);

      const res2 = await residentialNurseService.getPatientInfoById(idSurgery);
      setSurgeryDetail({ ...res, ...res2, ngayChiDinh: res2.ngayChiDinh });
      dispatch(setDetailInfo({ ...infoDataPatient, ...res, ...res2 }));

      // setAllPatient((pre) => ({ ...pre, ...res }));

      dispatch(setIsChangetab(false));
      setLoading(false);
      Notification("success", "Lưu dữ liệu thành công");
    } catch (error) {
      Notification("error", "Lưu dữ liệu thất bại");
      setLoading(false);
    }
  };
  const handleSaveAndPrint = async () => {
    modalRef.current?.openModal();
  };

  const handlePrintCertificate = () => {
    modalRefSurgeryCertificate.current?.openModal();
  };

  const handlePause = async () => {
    if (infoDataPatient?.idTrangThaiPhauThuat == 2) {
      await postStatusDiagnoseForm(1, "chờ phẫu thuật");
      dispatch(setActiveKey(residentialNurse.SURGERY.LIST_PATIENT));
      dispatch(setIsChangetab(false));
    } else {
      Notification(
        "warning",
        "Chỉ tạm dừng khi phiếu ở trạng thái Đang thực hiện"
      );
    }
  };

  const handleCancel = async () => {
    await postStatusDiagnoseForm(4, "hủy khám");
  };

  useEffect(() => {
    if (activeKey != residentialNurse.SURGERY.INFO_DETAIL) {
      dispatch(setButtonsHeader([]));
    } else {
      getPatientInfo();
      getDetailInfoById();
    }
  }, [activeKey]);

  useEffect(() => {
    if (
      listButton.length > 0 &&
      activeKey == residentialNurse.SURGERY.INFO_DETAIL
    ) {
      dispatch(setButtonsHeader(listButton));
    }
  }, [listButton]);

  useEffect(() => {
    if (activeKey == residentialNurse.SURGERY.INFO_DETAIL) {
      dispatch(setButtonsHeader(listButton));
    } else {
      dispatch(setIsChangetab(false));
    }
  }, [activeKey]);

  useEffect(() => {
    if (infoDataPatient?.idTrangThaiPhauThuat == 3) {
      setListButton([
        Save(handleSave),
        SaveAndPrint(handleSaveAndPrint, "In phiếu"),
        PrintCertificate(handlePrintCertificate),
        Completed(handleComplete, "Hoàn thành PT"),
        Cancel(handleCancel),
        Pause(handlePause),
      ]);
    } else if (infoDataPatient?.idTrangThaiPhauThuat == 6) {
      setListButton([
        Save(handleSave),
        SaveAndPrint(handleSaveAndPrint, "In phiếu"),
        PrintCertificate(handlePrintCertificate),
        Completed(handleComplete, "Hoàn thành PT"),
        Cancel(handleCancel),
        Pause(handlePause),
      ]);
    } else
      setListButton([
        Save(handleSave),
        SaveAndPrint(handleSaveAndPrint, "In phiếu"),
        PrintCertificate(handlePrintCertificate),
        Completed(handleComplete, "Hoàn thành PT"),
        Cancel(handleCancel),
        Pause(handlePause),
      ]);
  }, [infoDataPatient]);

  useEffect(() => {
    if (idSurgery === null) {
      dispatch(setActiveKey(residentialNurse.SURGERY.LIST_PATIENT));
    }
  }, [idSurgery]);

  return (
    <Spin spinning={loading}>
      <Row className="detail-info-surgery">
        <Space direction="vertical">
          <div className="container">
            <div className="title">Thông tin bênh nhân</div>
            <PatientInfo ref={patientInfoRef} dataSurgery={detailInfo} />
          </div>
          <div className="container">
            <StepInfo />
          </div>
          <div className="container">
            <div className="title">Nhân sự phẫu thuật</div>
            <PersonalInfo
              dataPersonalInfo={personalInfo}
              ref={personalInfoRef}
              infoPatient={infoDataPatient}
            />
          </div>

          <div className="container">
            <div className="title">Chi tiết quá trình phẫu thuật</div>
            <SurgeryDetail
              allSurgeryDetailInfo={surgeryDetail}
              infoPatient={infoDataPatient}
              ref={surgeryDetailRef}
            />
          </div>
        </Space>
      </Row>
      <ModalCustom ref={modalRef} width={1100} title="In phiếu phẫu thuật">
        <PrintPhieuPT surgeryDetail={surgeryDetail} />
      </ModalCustom>
      <ModalCustom ref={modalRefSurgeryCertificate} width={1100}>
        <SurgeryCertificate />
      </ModalCustom>
      {/* Cảnh báo quá hạn ngày */}
    </Spin>
  );
};

export default DetailInfo;
